import { entries, isFunction, each } from 'lodash';
import { isPossibleNumber, isValidPhoneNumber as _isValidPhoneNumber } from 'libphonenumber-js';
import styled from 'styled-components';

import { FormGroup } from 'bs/Input';

export function getFormData(form) {
    // 'form' is a <form> element
    const data = {};
    for (const [key, value] of new FormData(form).entries()) {
        data[key] = value;
    }
    return data;
}
export const addressTypeOptions = [
    { value: 'residence', label: 'Residence' },
    { value: 'business', label: 'Business' },
    { value: 'po', label: 'P.O. Box' },
];

export const countryChoices = [
    ['BS', 'Bahamas'],
    ['BM', 'Bermuda'],
    ['VG', 'British Virgin Islands'],
    ['KY', 'Cayman Islands'],
    ['US', 'United States'],
    ['AF', 'Afghanistan'],
    ['AX', 'Åland Islands'],
    ['AL', 'Albania'],
    ['DZ', 'Algeria'],
    ['AS', 'American Samoa'],
    ['AD', 'Andorra'],
    ['AO', 'Angola'],
    ['AI', 'Anguilla'],
    ['AQ', 'Antarctica'],
    ['AG', 'Antigua and Barbuda'],
    ['AR', 'Argentina'],
    ['AM', 'Armenia'],
    ['AW', 'Aruba'],
    ['AU', 'Australia'],
    ['AT', 'Austria'],
    ['AZ', 'Azerbaijan'],
    ['BH', 'Bahrain'],
    ['BD', 'Bangladesh'],
    ['BB', 'Barbados'],
    ['BY', 'Belarus'],
    ['BE', 'Belgium'],
    ['BZ', 'Belize'],
    ['BJ', 'Benin'],
    ['BT', 'Bhutan'],
    ['BO', 'Bolivia, Plurinational State of'],
    ['BQ', 'Bonaire, Sint Eustatius and Saba'],
    ['BA', 'Bosnia and Herzegovina'],
    ['BW', 'Botswana'],
    ['BV', 'Bouvet Island'],
    ['BR', 'Brazil'],
    ['IO', 'British Indian Ocean Territory'],
    ['BN', 'Brunei Darussalam'],
    ['BG', 'Bulgaria'],
    ['BF', 'Burkina Faso'],
    ['BI', 'Burundi'],
    ['KH', 'Cambodia'],
    ['CM', 'Cameroon'],
    ['CA', 'Canada'],
    ['CV', 'Cape Verde'],
    ['CF', 'Central African Republic'],
    ['TD', 'Chad'],
    ['CL', 'Chile'],
    ['CN', 'China'],
    ['CX', 'Christmas Island'],
    ['CC', 'Cocos (Keeling) Islands'],
    ['CO', 'Colombia'],
    ['KM', 'Comoros'],
    ['CG', 'Congo'],
    ['CD', 'Congo, the Democratic Republic of the'],
    ['CK', 'Cook Islands'],
    ['CR', 'Costa Rica'],
    ['CI', "Côte d'Ivoire"],
    ['HR', 'Croatia'],
    ['CU', 'Cuba'],
    ['CW', 'Curaçao'],
    ['CY', 'Cyprus'],
    ['CZ', 'Czech Republic'],
    ['DK', 'Denmark'],
    ['DJ', 'Djibouti'],
    ['DM', 'Dominica'],
    ['DO', 'Dominican Republic'],
    ['EC', 'Ecuador'],
    ['EG', 'Egypt'],
    ['SV', 'El Salvador'],
    ['GQ', 'Equatorial Guinea'],
    ['ER', 'Eritrea'],
    ['EE', 'Estonia'],
    ['ET', 'Ethiopia'],
    ['FK', 'Falkland Islands (Malvinas)'],
    ['FO', 'Faroe Islands'],
    ['FJ', 'Fiji'],
    ['FI', 'Finland'],
    ['FR', 'France'],
    ['GF', 'French Guiana'],
    ['PF', 'French Polynesia'],
    ['TF', 'French Southern Territories'],
    ['GA', 'Gabon'],
    ['GM', 'Gambia'],
    ['GE', 'Georgia'],
    ['DE', 'Germany'],
    ['GH', 'Ghana'],
    ['GI', 'Gibraltar'],
    ['GR', 'Greece'],
    ['GL', 'Greenland'],
    ['GD', 'Grenada'],
    ['GP', 'Guadeloupe'],
    ['GU', 'Guam'],
    ['GT', 'Guatemala'],
    ['GG', 'Guernsey'],
    ['GN', 'Guinea'],
    ['GW', 'Guinea-Bissau'],
    ['GY', 'Guyana'],
    ['HT', 'Haiti'],
    ['HM', 'Heard Island and McDonald Islands'],
    ['VA', 'Holy See (Vatican City State)'],
    ['HN', 'Honduras'],
    ['HK', 'Hong Kong'],
    ['HU', 'Hungary'],
    ['IS', 'Iceland'],
    ['IN', 'India'],
    ['ID', 'Indonesia'],
    ['IR', 'Iran, Islamic Republic of'],
    ['IQ', 'Iraq'],
    ['IE', 'Ireland'],
    ['IM', 'Isle of Man'],
    ['IL', 'Israel'],
    ['IT', 'Italy'],
    ['JM', 'Jamaica'],
    ['JP', 'Japan'],
    ['JE', 'Jersey'],
    ['JO', 'Jordan'],
    ['KZ', 'Kazakhstan'],
    ['KE', 'Kenya'],
    ['KI', 'Kiribati'],
    ['KP', "Korea, Democratic People's Republic of"],
    ['KR', 'Korea, Republic of'],
    ['KW', 'Kuwait'],
    ['KG', 'Kyrgyzstan'],
    ['LA', "Lao People's Democratic Republic"],
    ['LV', 'Latvia'],
    ['LB', 'Lebanon'],
    ['LS', 'Lesotho'],
    ['LR', 'Liberia'],
    ['LY', 'Libya'],
    ['LI', 'Liechtenstein'],
    ['LT', 'Lithuania'],
    ['LU', 'Luxembourg'],
    ['MO', 'Macao'],
    ['MK', 'Macedonia, the former Yugoslav Republic of'],
    ['MG', 'Madagascar'],
    ['MW', 'Malawi'],
    ['MY', 'Malaysia'],
    ['MV', 'Maldives'],
    ['ML', 'Mali'],
    ['MT', 'Malta'],
    ['MH', 'Marshall Islands'],
    ['MQ', 'Martinique'],
    ['MR', 'Mauritania'],
    ['MU', 'Mauritius'],
    ['YT', 'Mayotte'],
    ['MX', 'Mexico'],
    ['FM', 'Micronesia, Federated States of'],
    ['MD', 'Moldova, Republic of'],
    ['MC', 'Monaco'],
    ['MN', 'Mongolia'],
    ['ME', 'Montenegro'],
    ['MS', 'Montserrat'],
    ['MA', 'Morocco'],
    ['MZ', 'Mozambique'],
    ['MM', 'Myanmar'],
    ['NA', 'Namibia'],
    ['NR', 'Nauru'],
    ['NP', 'Nepal'],
    ['NL', 'Netherlands'],
    ['NC', 'New Caledonia'],
    ['NZ', 'New Zealand'],
    ['NI', 'Nicaragua'],
    ['NE', 'Niger'],
    ['NG', 'Nigeria'],
    ['NU', 'Niue'],
    ['NF', 'Norfolk Island'],
    ['MP', 'Northern Mariana Islands'],
    ['NO', 'Norway'],
    ['OM', 'Oman'],
    ['PK', 'Pakistan'],
    ['PW', 'Palau'],
    ['PS', 'Palestinian Territory, Occupied'],
    ['PA', 'Panama'],
    ['PG', 'Papua New Guinea'],
    ['PY', 'Paraguay'],
    ['PE', 'Peru'],
    ['PH', 'Philippines'],
    ['PN', 'Pitcairn'],
    ['PL', 'Poland'],
    ['PT', 'Portugal'],
    ['PR', 'Puerto Rico'],
    ['QA', 'Qatar'],
    ['RE', 'Réunion'],
    ['RO', 'Romania'],
    ['RU', 'Russian Federation'],
    ['RW', 'Rwanda'],
    ['BL', 'Saint Barthélemy'],
    ['SH', 'Saint Helena, Ascension and Tristan da Cunha'],
    ['KN', 'Saint Kitts and Nevis'],
    ['LC', 'Saint Lucia'],
    ['MF', 'Saint Martin (French part)'],
    ['PM', 'Saint Pierre and Miquelon'],
    ['VC', 'Saint Vincent and the Grenadines'],
    ['WS', 'Samoa'],
    ['SM', 'San Marino'],
    ['ST', 'Sao Tome and Principe'],
    ['SA', 'Saudi Arabia'],
    ['SN', 'Senegal'],
    ['RS', 'Serbia'],
    ['SC', 'Seychelles'],
    ['SL', 'Sierra Leone'],
    ['SG', 'Singapore'],
    ['SX', 'Sint Maarten (Dutch part)'],
    ['SK', 'Slovakia'],
    ['SI', 'Slovenia'],
    ['SB', 'Solomon Islands'],
    ['SO', 'Somalia'],
    ['ZA', 'South Africa'],
    ['GS', 'South Georgia and the South Sandwich Islands'],
    ['SS', 'South Sudan'],
    ['ES', 'Spain'],
    ['LK', 'Sri Lanka'],
    ['SD', 'Sudan'],
    ['SR', 'Suriname'],
    ['SJ', 'Svalbard and Jan Mayen'],
    ['SZ', 'Swaziland'],
    ['SE', 'Sweden'],
    ['CH', 'Switzerland'],
    ['SY', 'Syrian Arab Republic'],
    ['TW', 'Taiwan, Province of China'],
    ['TJ', 'Tajikistan'],
    ['TZ', 'Tanzania, United Republic of'],
    ['TH', 'Thailand'],
    ['TL', 'Timor-Leste'],
    ['TG', 'Togo'],
    ['TK', 'Tokelau'],
    ['TO', 'Tonga'],
    ['TT', 'Trinidad and Tobago'],
    ['TN', 'Tunisia'],
    ['TR', 'Turkey'],
    ['TM', 'Turkmenistan'],
    ['TC', 'Turks and Caicos Islands'],
    ['TV', 'Tuvalu'],
    ['UG', 'Uganda'],
    ['UA', 'Ukraine'],
    ['AE', 'United Arab Emirates'],
    ['GB', 'United Kingdom'],
    ['UM', 'United States Minor Outlying Islands'],
    ['UY', 'Uruguay'],
    ['UZ', 'Uzbekistan'],
    ['VU', 'Vanuatu'],
    ['VE', 'Venezuela, Bolivarian Republic of'],
    ['VN', 'Viet Nam'],
    ['VI', 'Virgin Islands, U.S.'],
    ['WF', 'Wallis and Futuna'],
    ['EH', 'Western Sahara'],
    ['YE', 'Yemen'],
    ['ZM', 'Zambia'],
    ['ZdW', 'Zimbabwe'],
];

export const countryOptions = countryChoices.map(choice => {
    return { value: choice[0], label: choice[1] };
});

// VALIDATION
export const emailPattern = /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,24}$/i;
export const isValidEmail = value => Boolean(emailPattern.test(value));
export const isRequired = value => (value ? '' : 'Required.');
export const isBoolean = value => (typeof value === 'boolean' ? '' : 'Required.');
export const isTrue = value => (
    typeof value === 'boolean' && value === true ? '' : 'Required.'
);
export const isEmail = value => {
    if (value && !isValidEmail(value)) {
        return 'Invalid email address.';
    }
};

const urlPattern = /^(?:(?:https?):\/\/)(?:\S+(?::\S*)?@)?(?:(?!(?:10|127)(?:\.\d{1,3}){3})(?!(?:169\.254|192\.168)(?:\.\d{1,3}){2})(?!172\.(?:1[6-9]|2\d|3[0-1])(?:\.\d{1,3}){2})(?:[1-9]\d?|1\d\d|2[01]\d|22[0-3])(?:\.(?:1?\d{1,2}|2[0-4]\d|25[0-5])){2}(?:\.(?:[1-9]\d?|1\d\d|2[0-4]\d|25[0-4]))|(?:(?:[a-z\u00a1-\uffff0-9]-*)*[a-z\u00a1-\uffff0-9]+)(?:\.(?:[a-z\u00a1-\uffff0-9]-*)*[a-z\u00a1-\uffff0-9]+)*(?:\.(?:[a-z\u00a1-\uffff]{2,}))\.?)(?::\d{2,5})?(?:[/?#]\S*)?$/i;
const isValidUrl = value => Boolean(urlPattern.test(value));
export const isUrl = value => {
    if (value && !isValidUrl(value)) {
        return 'Invalid web address. Example: "https://example.com"';
    }
};

export const acceptedFileTypes = ['.txt', '.pdf', '.jpg', '.jpeg', '.png'];

export const makeLengthValidator = length => value => {
    if (value && value.length < length) {
        return `Must be at least ${length} characters.`;
    }
};

export const isMinOfFive = makeLengthValidator(5);

export const isPhoneNumber = (value = '', country = 'us') => {
    if (value && !isPossibleNumber(value, country.toUpperCase())) {
        return 'Invalid telephone number.';
    }
};

export const matchesRegex = (value = '', regexPattern = /.*/, error='Invalid input.') => {
    if (value && !regexPattern.test(value)) {
        return error;
    }
};

export const isValidPhoneNumber = (value = '') => {
    if (!value) {
        return '';
    }

    // our API will default to adding the +1 if not provided
    // but libphonenumber-js won't take that so we just add it
    // here for validation b/c all our jurisdictions use it)
    let _value = value;
    if (!value.startsWith('+')) {
        _value = `+1 ${value}`;
    }

    if (!_isValidPhoneNumber(_value)) {
        return 'Invalid telephone number.';
    }
};

export const validator = (values = {}, fields = {}, callback = undefined) => {
    const errors = {};
    const errorMapper = (values, fields, errors) => {
        const validate = (validator, value, errorList) => {
            const error = validator(value);
            if (error) {
                errorList.push(error);
            }
        };

        entries(fields).map(([fieldName, validators]) => {
            let fieldErrors = [];
            const value = values[fieldName];

            if (isFunction(validators)) {
                validate(validators, value, fieldErrors);
            } else {
                validators.forEach(validator => {
                    validate(validator, value, fieldErrors);
                });
            }

            if (fieldErrors.length > 0) {
                errors[fieldName] = fieldErrors.join(' ');
            }
            return errors;
        });
    };

    errorMapper(values, fields, errors);

    if (callback) {
        callback(values, errors);
    }

    return errors;
};

export const chainValidators = (...validators) => {
    return value => {
        let errors = [];
        each(validators, validator => {
            const result = validator(value);
            if (result) {
                errors.push(result);
            }
        });
        if (errors.length) {
            return errors;
        }
    };
};

export const reactSelectStyle = {
    // allow paste menu on right-click and just ctrl-v is all in the style
    // - the default 2px width in there somewhere input should be the size of the component so when clicking on the component the browser will recognize it as an input
    // - the placeholder needs to be ignored, otherwise its copy is selectable to copy/paste
    // https://github.com/JedWatson/react-select/issues/4461
    placeholder: (provided) => ({
        ...provided,
        pointerEvents: 'none',
        userSelect: 'none',
        MozUserSelect: 'none',
        WebkitUserSelect: 'none',
        msUserSelect: 'none'
    }),
    input: (css) => ({
        ...css,
        flex: '1 1 auto',
        '> div': {
            width: '100%'
        },
        input: {
            width: '100% !important',
            textAlign: 'left'
        }
    })
};

export const FileInputStyle = styled(FormGroup)`
    padding: 2px 0;
    input {
        width: 100%;
    }
    .form-control {
        border: none;
        padding-left: 0;
        margin-bottom: 1em;
    }
    .file-info {
        padding-left: 0;
        margin-bottom: 0;
        list-style: none;
        li {
            color: ${props => props.theme.color.textMuted};
            border-color: ${props => props.theme.color.borderPrimary};
            background: white;
            margin-bottom: 1rem;
            padding: 0.375rem 0.75rem;
            strong {
                color: ${props => props.theme.color.primary};
            }
        }
    }
    .is-invalid .file-info li {
        border: solid 1px ${props => props.theme.color.borderDanger} !important;
        color: ${props => props.theme.color.danger} !important;
    }
    small {
        margin: -0.5rem 0 1rem;
        font-size: 95%;
    }
`;

// rjsf file field dataurl construction
// https://github.com/rjsf-team/react-jsonschema-form/blob/main/packages/core/src/components/widgets/FileWidget.tsx

function addNameToDataURL(dataURL, name) {
    if (dataURL === null) {
        return null;
    }
    return dataURL.replace(';base64', `;name=${encodeURIComponent(name)};base64`);
}

const processFile = file => {
    const { name, size, type } = file;
    return new Promise((resolve, reject) => {
        const reader = new window.FileReader();
        reader.onerror = reject;
        reader.onload = (event) => {
            if (typeof event.target?.result === 'string') {
                resolve({
                    dataURL: addNameToDataURL(event.target.result, name),
                    name,
                    size,
                    type,
                });
            } else {
                resolve({
                    dataURL: null,
                    name,
                    size,
                    type,
                });
            }
        };
        reader.readAsDataURL(file);
    });
};

export function processFiles(files) {
    return Promise.all(Array.from(files).map(processFile));
}
